import React from "react";
import { MAT_STATUS } from "@/lib/materials";

export function MaterialStatus({ status, testid }) {
  const s = MAT_STATUS[status] || MAT_STATUS.ok;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md border text-[11px] font-semibold ${s.cls}`} data-testid={testid}>
      <span className={`w-2 h-2 rounded-full ${s.dot}`} />{s.label}
    </span>
  );
}
